<template>
  <standard-dialog
    v-model="model"
    icon="mdi-truck-delivery"
    :title="toLatin(deliveryCompany?.name || '')"
    :subtitle="deliveryCompany?.id ? 'ID: ' + deliveryCompany.id : ''"
    :max-width="1600"
    @close="close"
    @save="save"
  >
    <table style="width: 100%; text-align: left" class="table table-striped">
      <thead>
        <tr>
          <th
            style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); padding: 7px"
            scope="row"
          >
            {{ $t("name") }}
          </th>
          <th
            style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); padding: 7px"
            scope="row"
          >
            {{ $t("delivery") }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="user in deliveryCompanyUsers"
          :key="user.id"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)"
        >
          <td style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); padding: 7px">
            {{ toLatin(user.user.name) }} {{ toLatin(user.user.lastname) }}
          </td>
          <td style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); padding: 7px">ddpx</td>
        </tr>
      </tbody>
    </table>
  </standard-dialog>
</template>

<script>
import StandardDialog from "@/components/dialogs/StandardDialog.vue";
import hasModel from "@/mixins/hasModel";

export default {
  name: "DeliveryReportDialog",
  components: {
    StandardDialog,
  },
  mixins: [hasModel],
  props: {
    deliveryCompany: {
      type: Object,
      default: () => ({}),
    },
    deliveryCompanyUsers: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      // TODO: Implement save logic if needed
      this.$emit("save");
      this.close();
    },
  },
};
</script>
